import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Bell, MessageSquare, Inbox, ChevronRight, Megaphone } from "lucide-react";

const META = {
  chat: { to: "/dashboard/messages", label: "Responder", Icon: MessageSquare, color: "text-primary" },
  lead: { to: "/dashboard/leads", label: "Ver solicitud", Icon: Inbox, color: "text-accent" },
  admin: { to: null, label: "", Icon: Megaphone, color: "text-slate-400" },
};

export default function Notifications() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/businesses/notifications/history")
      .then((r) => { setItems(r.data); return api.post("/businesses/notifications/mark-read"); })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="notifications-page">
      <h1 className="flex items-center gap-2 font-head text-2xl font-extrabold tracking-tight text-secondary"><Bell className="h-6 w-6 text-primary" /> {t("dash_notifications")}</h1>
      <p className="mt-1 text-sm text-slate-500">Toca una notificación para ir a responder o ver los detalles.</p>
      <div className="mt-6 space-y-3">
        {items.map((n, i) => {
          const meta = META[n.type] || META.admin;
          const clickable = !!meta.to;
          const Icon = meta.Icon;
          return (
            <div
              key={n.id || i}
              role={clickable ? "button" : undefined}
              tabIndex={clickable ? 0 : undefined}
              onClick={() => clickable && navigate(meta.to)}
              onKeyDown={(e) => clickable && e.key === "Enter" && navigate(meta.to)}
              className={`flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-4 transition-shadow ${clickable ? "cursor-pointer hover:shadow-md" : ""}`}
              data-testid={`notif-item-${i}`}
            >
              <span className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 ${meta.color}`}><Icon className="h-4 w-4" /></span>
              <div className="min-w-0 flex-1">
                <p className="font-head font-bold text-secondary">{n.subject || (n.type === "admin" ? "Notificación" : n.type)}</p>
                {n.body && <p className="mt-1 whitespace-pre-line text-sm text-slate-700">{n.body}</p>}
                <p className="mt-1 text-xs text-slate-400">{(n.created_at || "").slice(0, 16).replace("T", " ")}{n.type === "admin" ? " · Administrador" : ""}</p>
              </div>
              {clickable && (
                <span className={`flex shrink-0 items-center gap-1 self-center text-sm font-bold ${meta.color}`} data-testid={`notif-action-${i}`}>
                  {meta.label} <ChevronRight className="h-4 w-4" />
                </span>
              )}
            </div>
          );
        })}
        {items.length === 0 && <p className="rounded-xl border border-dashed border-slate-200 p-10 text-center text-slate-400">No tienes notificaciones.</p>}
      </div>
    </div>
  );
}
